export enum DeprecatedFeatureType {
  FeatureSupportUpdate = 'FeatureSupportUpdate',
  EquipmentSupportUpdate = 'EquipmentSupportUpdate',
}

export interface DeprecatedConsole {
  consoleName: string;
  consoleType: string;
}
